export default "__VITE_ASSET__BUpcFRUs__"